import { menuTypeDict } from '@/dictionary/menu'
import { companyTypeDict } from '@/dictionary/company'
import {
  platformFunctionModuleDict,
  workbenchServiceDict
} from '@/dictionary/system'

/**
 * 在线签章
 */
export default {
  path: 'signature',
  type: menuTypeDict.DIRECTORY.value,
  meta: {
    title: '在线签章',
    layout: 'DefaultLayout'
  },
  applicableCompanyTypes: [
    { companyType: companyTypeDict.ENTERPRISE.value },
    { companyType: companyTypeDict.PUBLIC_INSTITUTION.value },
    { companyType: companyTypeDict.SELF_EMPLOYEE.value }
  ],
  platformAlias: [],
  applicableCompanyIdentities: [workbenchServiceDict.SUPPLIER.value, workbenchServiceDict.AGENCY.value],
  roles: [
    platformFunctionModuleDict.SIGNATURE_MANAGEMENT.right,
    platformFunctionModuleDict.BUSINESS_MANAGEMENT.right,
    platformFunctionModuleDict.SIGNATURE_TASK.right
  ],
  superviseInstitutions: [],

  children: [
    // 签章次数
    {
      path: 'electronic',
      type: menuTypeDict.DIRECTORY.value,
      meta: {
        title: '签章次数',
        icon: 'icon-side_ca_signature_online'
      },
      applicableCompanyTypes: [
        { companyType: companyTypeDict.ENTERPRISE.value },
        { companyType: companyTypeDict.PUBLIC_INSTITUTION.value },
        { companyType: companyTypeDict.SELF_EMPLOYEE.value }
      ],
      platformAlias: [],
      applicableCompanyIdentities: [workbenchServiceDict.SUPPLIER.value, workbenchServiceDict.AGENCY.value],
      roles: [
        platformFunctionModuleDict.SIGNATURE_MANAGEMENT.right,
        platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
      ],
      superviseInstitutions: [],

      children: [
        // 签章开通
        {
          path: 'open',
          name: 'SignatureOpen',
          component: '/signature-views/electronic-signature/signature-open',
          type: menuTypeDict.MENU.value,
          meta: {
            title: '签章开通',
            hidden: true,
            layout: 'NavBarLayout'
          },
          applicableCompanyTypes: [
            { companyType: companyTypeDict.ENTERPRISE.value },
            { companyType: companyTypeDict.PUBLIC_INSTITUTION.value },
            { companyType: companyTypeDict.SELF_EMPLOYEE.value }
          ],
          platformAlias: [],
          applicableCompanyIdentities: [workbenchServiceDict.SUPPLIER.value, workbenchServiceDict.AGENCY.value],
          roles: [
            platformFunctionModuleDict.SIGNATURE_MANAGEMENT.right,
            platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
          ],
          superviseInstitutions: []
        },

        // 签章购买
        {
          path: 'buy',
          name: 'SignatureBuy',
          component: '/signature-views/electronic-signature/signature-buy',
          type: menuTypeDict.MENU.value,
          meta: {
            title: '签章购买',
            hidden: true
          },
          applicableCompanyTypes: [
            { companyType: companyTypeDict.ENTERPRISE.value },
            { companyType: companyTypeDict.PUBLIC_INSTITUTION.value },
            { companyType: companyTypeDict.SELF_EMPLOYEE.value }
          ],
          platformAlias: [],
          applicableCompanyIdentities: [workbenchServiceDict.SUPPLIER.value, workbenchServiceDict.AGENCY.value],
          roles: [
            platformFunctionModuleDict.SIGNATURE_MANAGEMENT.right,
            platformFunctionModuleDict.SIGNATURE_TASK.right,
            platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
          ],
          superviseInstitutions: []
        }
      ]
    },

    // 签章人员管理
    {
      path: 'member',
      name: 'SignatureMember',
      component: '/signature-views/member-management/index',
      type: menuTypeDict.MENU.value,
      meta: {
        title: '签章人员管理',
        icon: 'icon-side_ca_signature_manage'
      },
      applicableCompanyTypes: [
        { companyType: companyTypeDict.ENTERPRISE.value },
        { companyType: companyTypeDict.PUBLIC_INSTITUTION.value },
        { companyType: companyTypeDict.SELF_EMPLOYEE.value }
      ],
      platformAlias: [],
      applicableCompanyIdentities: [workbenchServiceDict.SUPPLIER.value, workbenchServiceDict.AGENCY.value],
      roles: [platformFunctionModuleDict.BUSINESS_MANAGEMENT.right],
      superviseInstitutions: []
    },

    // 签章任务
    {
      path: 'task',
      name: 'SignatureTask',
      component: '/signature-views/task-management/index',
      type: menuTypeDict.MENU.value,
      meta: {
        title: '签章任务',
        icon: 'icon-side_ca_signature_task'
      },
      applicableCompanyTypes: [
        { companyType: companyTypeDict.ENTERPRISE.value },
        { companyType: companyTypeDict.PUBLIC_INSTITUTION.value },
        { companyType: companyTypeDict.SELF_EMPLOYEE.value }
      ],
      platformAlias: [],
      applicableCompanyIdentities: [workbenchServiceDict.SUPPLIER.value, workbenchServiceDict.AGENCY.value],
      roles: [platformFunctionModuleDict.SIGNATURE_TASK.right],
      superviseInstitutions: []
    }
  ]
}
